import { ICadDraftHeaderRequest, ICadDraftHeaderResponse, ICadInvoiceRequest, ICadInvoiceResponse } from '../api/cad-draft-api.model';

export const mapIDraftHeaderResponseToRequest = (draftResponse: ICadDraftHeaderResponse): ICadDraftHeaderRequest => {
  return {
    ...draftResponse,
  };
};

export const mapIDraftInvoiceResponseToRequest = (draftInvoiceResponse: ICadInvoiceResponse): ICadInvoiceRequest => {
  return {
    ...draftInvoiceResponse
  };
};
